'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItem as CartItemCard } from './cart-item/cart-item.component';

import { CartItem } from '@/types/cart.types';

interface CartItemsListProps {
  items: CartItem[];
}

export function CartItemsList({ items }: CartItemsListProps) {
  return (
    <ul
      className="flex flex-col gap-4 px-6 pb-5"
      data-testid={DataTestIdEnum.CART_ITEMS_LIST}
    >
      {items.map((item) => (
        <li key={item.id}>
          <CartItemCard item={item} />
        </li>
      ))}
    </ul>
  );
}
